import React from 'react';
import { motion } from 'framer-motion';

// A floating 3D decorative shape: mouse-parallax (outer) + load-in entrance (middle) + continuous idle float/spin (inner)
export const FloatingShape = ({ parallaxX, parallaxY, delay = 0, floatDuration = 5, spinDuration = 20, spinReverse = false, className = '', children, testId }) => {
  return (
    <motion.div style={{ x: parallaxX, y: parallaxY }} className={`hidden sm:block absolute ${className}`} data-testid={testId}>
      <motion.div
        initial={{ opacity: 0, scale: 0, rotate: -150 }}
        animate={{ opacity: 1, scale: 1, rotate: 0 }}
        transition={{ duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] }}
      >
        <motion.div
          animate={{ y: [0, -16, 0], rotateZ: spinReverse ? [360, 0] : [0, 360] }}
          transition={{
            y: { duration: floatDuration, repeat: Infinity, ease: 'easeInOut' },
            rotateZ: { duration: spinDuration, repeat: Infinity, ease: 'linear' },
          }}
        >
          {children}
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default FloatingShape;
